export default __webpack_public_path__ + "static/media/5A2_Porfirio_Gutierrez_by_recker.937a492c.jpg";